import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "@follosoft/react-components";
import type { BillingInfo } from "@/app/_checkout/types";

export const ME_KEY = "client-me";

// GET me → ClientResource for the authenticated client. The billing-relevant
// fields land either under data.attributes or flat on data depending on the
// guard, so read defensively.
interface MeClientFields {
  client_firstname?: string;
  client_lastname?: string;
  client_email?: string;
}

export function useMeService(token: string) {
  return useQuery<BillingInfo>({
    queryKey: [ME_KEY],
    queryFn: async () => {
      const res = await axiosInstance().get("me");
      const data = res.data?.data;
      const fields: MeClientFields = data?.attributes ?? data ?? {};
      return {
        first_name: fields.client_firstname ?? "",
        last_name: fields.client_lastname ?? "",
        email: fields.client_email ?? "",
        country: "CA",
        address: "",
      };
    },
    enabled: !!token,
    staleTime: Infinity,
    retry: false,
  });
}
